// assets
import { IconCalendar } from '@tabler/icons';
import permissioncheck from 'utils/permissioncheck';

// ==============================|| PAYMENT MENU ITEMS ||============================== //

const children = [
  {
    id: 'classschedule',
    perm: 'schedule.read',
    title: 'Jadwal Kelas',
    type: 'item',
    url: '/classschedule',
    icon: IconCalendar,
    breadcrumbs: false
  },
  {
    id: 'schedule',
    perm: 'schedule.read',
    title: 'Jadwal',
    type: 'item',
    url: '/schedule',
    icon: IconCalendar,
    breadcrumbs: false
  }
];
const list = {
  id: 'schedule',
  title: '',
  type: 'group',
  children: []
};

children.forEach((element) => {
  if (permissioncheck(element.perm)) {
    list.children.push(element);
  }
});

export default list;
